import cookie from 'react-cookie'
import { CookieDomain } from '../config.js'

var cookieConfig = {}
if (CookieDomain !== '') {
  cookieConfig = { domain: CookieDomain, path: '/' }
} else {
  cookieConfig = { domain: '', path: '/' }
}

export function saveCookie (name, value) {
  cookie.save(name, value, cookieConfig)
}

export function getCookie (name) {
  return cookie.load(name)
}

export function removeCookie (name) {
  cookie.remove(name, cookieConfig)
}

export function signIn (token, username) {
  cookie.remove('token', cookieConfig)
  cookie.remove('username', cookieConfig)
  cookie.save('token', token, cookieConfig)
  cookie.save('username', username, cookieConfig)
}

export function signOut () {
  cookie.save('token', '', cookieConfig)
  cookie.save('username', '', cookieConfig)
}

export function isLoggedIn () {
  return !!cookie.load('token')
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js